<form [formGroup]="formGroup" (submit)="submit()">
  <div class="text-center">
    {{ 'request_form.status.edit_reason.state_the_reason' | translate }}
  </div>
  <tui-textfield class="h-40 mt-3" tuiTextfieldSize="m">
    <textarea
      tuiTextarea
      [limit]="10_000"
      [formControlName]="FormFields.Reason"
      [min]="6"
      [max]="12"
    ></textarea>
  </tui-textfield>
  @if (reasonField?.touched) {
    @if (reasonField?.errors?.['required']) {
      <tui-error
        [error]="'request_form.status.edit_reason.no_value_error' | translate"
      ></tui-error>
    }
    @if (reasonField?.errors?.['maxlength']) {
      <tui-error
        [error]="'request_form.status.edit_reason.no_value_error' | translate"
      ></tui-error>
    }
  }
  <div class="flex justify-end mt-3">
    <button
      tuiButton
      type="button"
      size="m"
      class="mr-3"
      appearance="blue"
      (click)="dismiss()"
    >
      {{ 'request_form.status.edit_reason.close' | translate }}
    </button>
    <button
      tuiButton
      type="submit"
      size="m"
      appearance="primary"
      [disabled]="formGroup.invalid"
    >
      {{ 'request_form.status.edit_reason.change' | translate }}
    </button>
  </div>
</form>
